module.exports = __webpack_public_path__ + "img/email2 (2).d674a451.png";